module.exports = __webpack_public_path__ + "resources/img/zoom-ui-customizations-07.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/zoom-ui-customizations-07.png
// module id = 1403
// module chunks = 0